export default __webpack_public_path__ + "static/media/G0130.Adult_Choking_Algorithm_GS_april22.1666190100000.06e01c23.jpg";